<script lang="ts" setup>
const props = defineProps({
  color: {
    default: 'indigo',
    type: String as PropType<StepApiEndpointColor>,
  },
  id: {
    required: true,
    type: String as PropType<'datapoints' | ApiEndpointId>,
  },
})

const { getEndpoint } = useApiEndpoints()
const { t } = useI18n()
const localePath = useLocalePath()

const link = computed(() => {
  if (props.id === 'datapoints') {
    return {
      text: t('ourCompanyDatapoints'),
      to: localePath({
        name: 'api-slug',
        params: { slug: 'datapoints' },
      }),
    }
  }

  const endpoint = getEndpoint(props.id)

  return endpoint ?? {
    text: t('globals.wrongId'),
    to: undefined,
  }
})
</script>

<template>
  <UTooltip
    class="align-middle"
    :text="t('openDocumentation')"
  >
    <ULink
      v-if="link"
      class="ignore-step-style mx-0.5 inline-flex items-center whitespace-nowrap rounded-md px-1.5 py-0.5 text-sm lowercase ring-1 ring-inset ring-opacity-25 transition hover:ring-opacity-50 md:text-base dark:bg-opacity-10 dark:ring-opacity-25 dark:hover:ring-opacity-50"
      :class="{
        'bg-orange-50 text-orange-500 ring-orange-600 dark:bg-orange-400 dark:text-orange-400 dark:ring-orange-400': color === 'orange',
        'bg-green-50 text-green-500 ring-green-600 dark:bg-green-400 dark:text-green-400 dark:ring-green-400': color === 'green',
        'bg-purple-50 text-purple-500 ring-purple-600 dark:bg-purple-400 dark:text-purple-400 dark:ring-purple-400': color === 'purple',
        'bg-indigo-50 text-indigo-500 ring-indigo-600 dark:bg-indigo-400 dark:text-indigo-400 dark:ring-indigo-400': color === 'indigo',
      }"
      :to="link.to"
    >
      <UIcon
        class="mr-1 size-4 md:mr-1.5 md:size-5"
        :name="getIcon('api')"
      />

      {{ link.text }}
    </ULink>
  </UTooltip>
</template>

<i18n lang="json">
{
  "en": {
    "openDocumentation": "Open documentation",
    "ourCompanyDatapoints": "our company datapoints"
  },
  "es": {
    "openDocumentation": "Abrir documentación",
    "ourCompanyDatapoints": "nuestros datos de empresa"
  },
  "fr": {
    "openDocumentation": "Ouvrir la documentation",
    "ourCompanyDatapoints": "nos données d’entreprise"
  }
}
</i18n>
